import React from 'react';

const ShadowsList = () => {
  return (
    <div className="items">
      <div>
        <p className="editorial-large semibold mb-md">
          Shadows (
          <a
            className="editorial-large semibold underline"
            href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=18983-1651"
          >
            Reference
          </a>
          )
        </p>
        <p className="caption mb-xl">
          Example usage: <code className="code-example">class="shadow-level-1"</code>
        </p>
      </div>
      <div className="column section-wrap">
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div className="shadow-level-1 p-md m-md text-center">Level 1</div>
          <div className="shadow-level-2 p-md m-md text-center">Level 2</div>
          <div className="shadow-level-3 p-md m-md text-center">Level 3</div>
          <div className="shadow-level-4 p-md m-md text-center">Level 4</div>
        </div>
      </div>
    </div>
  );
};

export default ShadowsList;
